import Highcharts from 'highcharts';

/*import interfaces*/
import { Aeroval } from '../../types/global';
declare var aeroval: Aeroval;

import chartsStyle from '../../../public/config/charts-style.json'

type LineStyle = 'lineWidthFactor' | 'markerEnabledThreshold' | 'markerSize';
export function updateLineStyle(which: LineStyle, value: string): void {
	// update aeroval settings

	aeroval.settings[which] = value;

	const lineWidthFactor = aeroval.settings.lineWidthFactor ? Number(aeroval.settings.lineWidthFactor) : 1;
	const markerEnabledThreshold = aeroval.settings.markerEnabledThreshold ? Number(aeroval.settings.markerEnabledThreshold) : 2;
	//console.log('updateLineStyle', which, value, lineWidthFactor, markerEnabledThreshold);

	// redraw all charts
	Highcharts.charts.forEach(function (chart) {
		if (!chart) return;
		const chartType = chart?.options?.chart?.type as string;
		const isXaxisDatetime = (chart.options.xAxis as any)[0]?.type === 'datetime';
		const shouldUpdate = isXaxisDatetime || chart.options.chart?.renderTo === 'frcst-ts' || chart.options.chart?.renderTo === 'evaluation-ts' || ['line', 'spline'].includes(chartType);

		if (!shouldUpdate) return;
		const chartId = (chart as any).renderTo.id as keyof typeof chartsStyle

		if (chartId in chartsStyle) {
			console.log('updateLineStyle', which, value, chartId, chartsStyle[chartId]);
			// default lineWidth from chartsStyle
			for (const series of chart.series) {
				// check if style is defined for that series
				var useDefaultStyle = true
				var styleSeries = undefined
				for (const seriesKey in chartsStyle[chartId]) {
					if (series.userOptions.id?.startsWith(seriesKey.split('*')[0])) {
						useDefaultStyle = false
						styleSeries = (chartsStyle[chartId] as any)[seriesKey]
					}
				}

				var seriesWeight = (series.userOptions as any)?.weight ? (series.userOptions as any)?.weight : 1;
				// id can be defined as: mod-* and is supposed to define all ids starting with mod-
				if (useDefaultStyle) {
					(series as any).update({
						lineWidth: chartsStyle["default"]["*"].lineWidth * Number(lineWidthFactor) * seriesWeight,
						marker: {
							radius: chartsStyle["default"]["*"].markerSize * Number(lineWidthFactor) * seriesWeight,
							enabledThreshold: markerEnabledThreshold,
						}
					}, false)
				} else {
					(series as any).update({
						lineWidth: styleSeries.lineWidth * Number(lineWidthFactor) * seriesWeight,
						marker: {
							radius: styleSeries.markerSize * Number(lineWidthFactor) * seriesWeight,
							enabledThreshold: markerEnabledThreshold,
						}
					}, false)
				}
			}
		} else {
			console.warn('updateLineStyle: chartId not found in chartsStyle', chartId, chartsStyle);
			// default lineWidth: 2
			for (const series of chart.series) {
				var seriesWeight = (series.userOptions as any)?.weight ? (series.userOptions as any)?.weight : 1;
				(series as any).update({
					lineWidth: chartsStyle["default"]["*"].lineWidth * Number(lineWidthFactor) * seriesWeight,
					marker: {
						radius: chartsStyle["default"]["*"].markerSize * Number(lineWidthFactor) * seriesWeight,
						enabledThreshold: markerEnabledThreshold,
					}
				}, false)
			}
		}
		chart?.redraw()
		//}
	});
}
